import _Model from "./_Model";

export default class LicenseModelCategory extends _Model {
  constructor(json) {
    super(json);
    this.licenseModelCategoryKey = LicenseModelCategory.getOrDefault(json, 'licenseModelCategoryKey', '');
    this.applicationValue = LicenseModelCategory.getOrDefault(json, 'applicationValue', '');
    this.labelKey = LicenseModelCategory.getOrDefault(json, 'labelKey', '');
  }
}
